var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid #eee;\n  border-radius: 3;\n  background-color: #ffffff;\n  cursor: pointer;\n  font-size: 15;\n  padding: 3px 10px;\n  margin: 10px;\n"], ["\n  border: 1px solid #eee;\n  border-radius: 3;\n  background-color: #ffffff;\n  cursor: pointer;\n  font-size: 15;\n  padding: 3px 10px;\n  margin: 10px;\n"])));
Button.defaultProps = {
    type: 'button',
    onClick: function () { },
};
export default Button;
var templateObject_1;
//# sourceMappingURL=Button.js.map